import {Navigate, Outlet, useRoutes} from "react-router-dom";
import {urls} from "./urls";
import {Guard} from "./guards/Guard";
import {AuthLayout} from "pages/auth/AuthLayout";
import MenuLayout from "layout/MenuLayout";
import {lazy} from "react";
import {componentLoader, Loadable} from "@bounce/shared/helpers";

export default function Router() {
  return useRoutes([
    {
      path: urls.home.path,
      element: (
        <Guard>
          <MenuLayout />
        </Guard>
      ),
      children: [
        {
          path: urls.home.path,
          element: <Navigate to={urls.dashboard.url} replace />,
        },
        {
          path: urls.dashboard.path,
          element: <CollectionsDashboard />,
        },
        {
          path: urls.search.path,
          element: <Search />,
        },
        {
          path: urls.accountInformation.path,
          element: <AccountInformationPage />,
        },
        {
          path: urls.inventory.path,
          element: <Inventory />,
        },
        {
          path: urls.importDirectPayments.path,
          element: <ImportDirectPayments />,
        },
        {
          path: urls.importRecalls.path,
          element: <ImportRecalls />,
        },
        {
          path: urls.placeAccounts.path,
          element: <PlaceAccounts />,
        },
        {
          path: urls.reports.path,
          element: <Reports />,
        },
        {
          path: urls.disputes.path,
          element: <Disputes />,
        },
        {
          path: urls.documentRequests.path,
          element: <DocumentRequests />,
        },
      ],
    },
    {
      path: urls.partnerSelector.path,
      element: <PartnerSelector />,
    },
    // Auth Routes
    {
      path: urls.auth.path,
      element: (
        <AuthLayout>
          <Outlet />
        </AuthLayout>
      ),
      children: [
        {
          path: "",
          element: <EmailAuth />,
        },
        {
          path: urls.login.path,
          element: <Login />,
        },
        {
          path: urls.forgotPassword.path,
          element: <ForgotPassword />,
        },
        {
          path: urls.resetPasswordCode.path,
          element: <ResetPasswordCode />,
        },
        {
          path: urls.resetPasswordNew.path,
          element: <ResetPassword />,
        },
        {
          path: urls.newPasswordRequired.path,
          element: <SetNewPassword />,
        },
      ],
    },
    {
      path: "*",
      children: [{path: "*", element: <Navigate to={urls.home.url} replace />}],
    },
  ]);
}

const AccountInformationPage = Loadable(
  lazy(() => componentLoader(() => import("../pages/account-information/AccountInformationPage")))
);
const Search = Loadable(lazy(() => componentLoader(() => import("../pages/search/Search"))));
const PartnerSelector = Loadable(
  lazy(() => componentLoader(() => import("../pages/partner-selector/PartnerSelector")))
);
const Reports = Loadable(lazy(() => componentLoader(() => import("../pages/reports/Reports"))));
const Disputes = Loadable(lazy(() => componentLoader(() => import("../pages/disputes/Disputes"))));

const DocumentRequests = Loadable(
  lazy(() => componentLoader(() => import("../pages/document-requests/DocumentRequests")))
);
const EmailAuth = Loadable(lazy(() => componentLoader(() => import("../pages/auth/EmailAuth"))));
const Login = Loadable(lazy(() => componentLoader(() => import("../pages/auth/Login"))));
const ForgotPassword = Loadable(lazy(() => componentLoader(() => import("../pages/auth/ForgotPassword"))));
const ResetPasswordCode = Loadable(lazy(() => componentLoader(() => import("../pages/auth/ResetPasswordCode"))));
const SetNewPassword = Loadable(lazy(() => componentLoader(() => import("../pages/auth/SetNewPassword"))));
const ResetPassword = Loadable(lazy(() => componentLoader(() => import("../pages/auth/ResetPassword"))));

const Inventory = Loadable(lazy(() => componentLoader(() => import("../pages/inventory/Inventory"))));
const CollectionsDashboard = Loadable(
  lazy(() => componentLoader(() => import("../pages/collections-dashboard/CollectionsDashboard")))
);

const ImportDirectPayments = Loadable(
  lazy(() => componentLoader(() => import("../pages/bulk-operations/ImportDirectPayments")))
);
const ImportRecalls = Loadable(lazy(() => componentLoader(() => import("../pages/bulk-operations/ImportRecalls"))));
const PlaceAccounts = Loadable(lazy(() => componentLoader(() => import("../pages/bulk-operations/PlaceAccounts"))));
